// Global CSS classes
enum GlobalClass {
  ButtonPlain = "buttonPlain",
  HideText = "hideText",
  PixelArtImage = "pixelArtImage",
}

export default GlobalClass;
